import { CollectionType } from '@/@types';
import { UIComponent } from '@/components/core/components';
import { Trans } from '@lingui/react/macro';
import CarouselCollections from '@/components/core/components/organism/carousel/collections';
import * as styles from './collections.styles';

const Collections: UIComponent<{ collections: CollectionType[]; limit?: number }> = ({ collections, limit = 7 }) => {
  return (
    <div className={styles.root}>
      <h3 className={styles.title}>
        <Trans>The most recommended collections by the most relevant users</Trans>
      </h3>
      <CarouselCollections
        collections={collections
          .sort((a, b) => {
            return new Date(b.updatedAt!).getTime() - new Date(a.updatedAt!).getTime();
          })
          .slice(0, limit)}
      />
    </div>
  );
};

export default Collections;
